import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import ReactGA from 'react-ga'

import { ParallaxProvider } from 'react-scroll-parallax'
import { StaticQuery, graphql } from 'gatsby'

import Header from './header'
import Footer from './footer'

import 'flexboxgrid'
import 'tachyons'
import './layout.scss'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          link={[
            {
              rel: 'apple-touch-icon" sizes="180x180',
              href: '/apple-touch-icon.png',
            },
            {
              rel: 'icon" type="image/png" sizes="32x32',
              href: '/favicon-32x32.png',
            },
            {
              rel: 'icon" type="image/png" sizes="16x16',
              href: '/favicon-16x16.png',
            },
            { rel: 'manifest', href: '/site.webmanifest' },
            {
              rel: 'mask-icon',
              href: '/safari-pinned-tab.svg" color="#042e6f',
            },
          ]}
          meta={[
            {
              name: 'description',
              content:
                'Whether you are an individual, have a website, a mobile app or a physical store, Paytm allows you to collect payments efficiently and reliably.',
            },
            { name: 'image', content: 'https://business.paytm.ca/cover.jpg' },
            { itemprop: 'name', content: 'Paytm Business' },
            {
              itemprop: 'description',
              content:
                'Whether you are an individual, have a website, a mobile app or a physical store, Paytm allows you to collect payments efficiently and reliably.',
            },
            {
              itemprop: 'image',
              content: 'https://business.paytm.ca/cover.jpg',
            },
            { property: 'og:title', content: 'Paytm Business' },
            {
              property: 'og:description',
              content:
                'Whether you are an individual, have a website, a mobile app or a physical store, Paytm allows you to collect payments efficiently and reliably.',
            },
            {
              property: 'og:image',
              content: 'https://business.paytm.ca/cover.jpg',
            },
            { property: 'og:url', content: 'https://business.paytm.ca/' },
            { property: 'og:site_name', content: 'Paytm Business' },
            { property: 'og:type', content: 'website' },
            { property: 'fb:app_id', content: '1259035637533513' },
            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:title', content: 'Paytm Business' },
            {
              name: 'twitter:description',
              content:
                'Whether you are an individual, have a website, a mobile app or a physical store, Paytm allows you to collect payments efficiently and reliably.',
            },
            { name: 'twitter:site', content: 'https://business.paytm.ca/' },
            { name: 'twitter:creator', content: '@paytm_canada' },
            {
              name: 'twitter:image:src',
              content: 'https://business.paytm.ca/cover.jpg',
            },
            {
              name: 'viewport',
              content: 'width=device-width, initial-scale=1.0',
            },
            { name: 'msapplication-TileColor', content: '#042e6f' },
            { name: 'theme-color', content: '#042e6f' },
            {
              name: 'description',
              content:
                'Whether you are an individual, have a website, a mobile app or a physical store, Paytm allows you to collect payments efficiently and reliably.',
            },
            {
              name: 'keywords',
              content:
                'paytm, paytm canada, merchants, digital payments, mobile payments, payments, alternative banking, bank better',
            },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <Header siteTitle={data.site.siteMetadata.title} />
        <ParallaxProvider>{children}</ParallaxProvider>
        <Footer />
      </>
    )}
  />
)

ReactGA.initialize('UA-125420870-2')
ReactGA.pageview(
  typeof window !== 'undefined' &&
    window.location.pathname + window.location.search
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
